import { cn } from "@/lib/utils"
interface FormStepProgressProps {
  currentStep: number
  max: number
}
export const FormStepProgress = ({
  currentStep,
  max,
}: FormStepProgressProps) => {
  const steps = Array.from({ length: max }, (_, index) => ({
    title: `Step ${index + 1}`,
  }))
  return (
    <nav aria-label="Progress" className="flex items-center justify-between">
      <ul role="list" className="flex gap-2">
        {steps.map((step, index) => (
          <li
            key={step.title}
            className={cn(
              "size-2 rounded-full bg-zinc-300 transition-all",
              currentStep === index && "w-6 bg-primary",
            )}
          />
        ))}
      </ul>
      <span className="text-sm text-muted-foreground">
        Passo {currentStep + 1} de {steps.length}
      </span>
    </nav>
  )
}
